module.exports = __webpack_public_path__ + "img/gzt.28a82f85.png";